function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.');
}

module.exports = _initializerWarningHelper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/initializerWarningHelper.js
// module id = X6mv
// module chunks = 2